<template>
  <div class="user-box">
    <div style="height: 20px"></div>
    <div class="flex container ">
      <div class="nav-box">
        <div class="nav-item flex" v-for="(v, i) in navs" :key="v" :class="[i == index ? 'on' : '']" @click="index = i">
          <component
            :is="$icon[v.icon ]"
            style="width: 20px; margin-right: 10px;position:relative;top: 1px"
          >
          </component>
          <div class="name">{{v.name}}</div>
        </div>
      </div>
      <div class="mian flex-item">
        <div class="content-box">
          <router-view />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { reactive, toRefs, watch } from "vue"
import { nanoid } from "nanoid"
import { useRouter } from "vue-router"
import { useStore } from "vuex"
import { api } from "@/api"
// import MyData from "@/components/common/user/myData.vue"
export default {
  name: "user-index",
  components: {
    // MyData
  },
  setup() {
    let Router = useRouter()
    let store = useStore()
    let initData = reactive({
      userInfo: "",
      navs: [
        {id: nanoid(), name: "账号资料", icon: "Postcard", path: "/user/index"},
        {id: nanoid(), name: "我的活动", icon: "Guide", path: "/user/active"},
        {id: nanoid(), name: "修改密码", icon: "Key", path: "/user/setPass"},
      ],
      index: 0
    })
    watch(() => store.state.userInfo, (newVal) => {
      if(!newVal) {
        Router.push("/")
      } 
      initData.userInfo = newVal
    }, {immediate: true})
    watch(() => initData.index, (val) => {
   
      Router.push({
        path: initData.navs[val].path
      })
    })
    // 这里处理一下其他地方更改资料
    api("get", "user", {id: initData.userInfo.id}).then(res => {
      if(res.code == 1200) {
        store.commit("setUserInfo", res.data)
        localStorage.setItem("whgUserInfo", JSON.stringify(res.data))
      }
    })
    return {
      ...toRefs(initData)
    }
  }
}
</script>

<style lang="less" scoped>
.user-box {
  min-height: calc(100vh - 80px);
  background-color: #f2f2f2;
  .nav-box {
    width: 200px;
    .nav-item {
      height: 60px;
      font-size: 16px;
      font-weight: 500;
      color: #222;
      align-items: center;
      border-bottom: 1px solid #e3e4e5;
      padding-left: 20px;
      box-sizing: border-box;
      letter-spacing: 2px;
      cursor: pointer;
      &:hover {
        color: #7cc29e;
      }
    }
    .nav-item.on {
      color: #07c160;
    }
  }
  .content-box {
    min-height: calc(100vh - 93px - 274px - 40px);
    // height: 100px;
    height: calc(100% - 20px);
    margin-left: 40px;
    padding: 20px;
    background-color: white;
    border-radius: 4px;
    box-sizing: border-box;
    
  }
}
</style>